import { Descendant, Node, Text } from 'slate';
import { CustomSlateNodeType } from '../types';

export const isDividingLineNode = (node: Descendant): boolean => {
  return node.type === CustomSlateNodeType.DIVIDING_LINE;
};

export const isNodeEmptyDefaultBlock = (node: Descendant): boolean => {
  if (node.type === CustomSlateNodeType.PARAGRAPH && !Node.string(node)) {
    return true;
  }
  return false;
};

export const flatBlockLevelDescendant = (node?: Descendant[]) => {
  if (node) {
    return node.reduce((destArr: Descendant[], currentNode: Descendant) => {
      if (currentNode.type === CustomSlateNodeType.PARAGRAPH) {
        return [...destArr, ...currentNode.children];
      }
      return [...destArr, currentNode];
    }, []);
  }
  return [];
};

export const getSlateEmptyValue = (): Descendant[] => {
  return [
    {
      type: CustomSlateNodeType.PARAGRAPH,
      children: [{ text: '' }],
    },
  ];
};

export const getMustacheEmptyValue = (): string => {
  return '#mustache#';
};

export function SlateValueIsEmpty(segments: Descendant[]): boolean {
  const dest = segments.filter((node) => {
    if (Text.isText(node)) {
      return node.text.trim();
    }
    if (node.type === CustomSlateNodeType.IMAGE) {
      return node.images.length;
    }
    if (node.type !== CustomSlateNodeType.DIVIDING_LINE) {
      return true;
    }
    return false;
  });

  return dest.length === 0;
}

export function SlateValueImageNodeIsError(segments: Descendant[]): boolean {
  return segments.some((segment) => {
    return (
      segment.type === CustomSlateNodeType.IMAGE &&
      segment.images.some((imageInfo) => !imageInfo.imageId)
    );
  });
}
